/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UploadFile } from './UploadFile'
export type SectionsLogosComponent = {
  id?: number
  __component?: string
  title?: string
  visuals?: Array<UploadFile>
  style?: SectionsLogosComponent.style
  url?: string
}
export namespace SectionsLogosComponent {
  export enum style {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
    TERTIARY = 'Tertiary',
  }
}
